import { GET_PROD_DATA_SOURCE_THIS_MONTH } from '../../actions/types';

const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_PROD_DATA_SOURCE_THIS_MONTH:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
}
